import { AwsRum } from 'aws-rum-web';
import {
  rumApplicationId,
  rumApplicationVersion,
  rumIdentityPoolId,
  rumEndpoint,
  awsRegion,
} from '../config';
import invariant from 'tiny-invariant';

let awsRum;

export const initializeRum = () => {
  invariant(!awsRum, 'RUM SDK already initialized');
  try {
    const config = {
      sessionSampleRate: 1,
      identityPoolId: rumIdentityPoolId,
      endpoint: rumEndpoint,
      telemetries: ['errors', 'https', 'performance'],
      allowCookies: true,
      enableXRay: false,
    };

    awsRum = new AwsRum(
      rumApplicationId,
      rumApplicationVersion,
      awsRegion,
      config,
    );
    console.log('RUM SDK initialized successfully.');
  } catch (error) {
    console.error('Failed to initialize RUM SDK', error);
  }
};

export function recordRumEvent(eventType, eventDetails) {
  awsRum?.recordEvent(eventType, eventDetails);
}

export function recordRumError(error) {
  awsRum?.recordError(error);
}
